import { render, staticRenderFns } from "./ReviewDetailCard.vue?vue&type=template&id=56232464&scoped=true"
import script from "./ReviewDetailCard.vue?vue&type=script&lang=js"
export * from "./ReviewDetailCard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56232464",
  null
  
)

export default component.exports